import { Button } from "@/components/ui";
import { ProfessionalRole, useUser } from "@/network/useUser";
import { CopyIcon } from "lucide-react";

export const FHIRIdentifierCopier = ({ id }: { id: string }) => {
  const { data: user } = useUser();

  if (user?.professional?.role !== ProfessionalRole.ENGINEER) {
    return null;
  }

  return (
    <Button
      className="p-0 m-0"
      variant="icon"
      onClick={() => {
        navigator.clipboard.writeText(id);
      }}
    >
      <CopyIcon size={12} strokeWidth={1} />
    </Button>
  );
};
